import React from 'react'
import {
  Query
} from 'react-apollo'

import Loading from '../../atoms/Loading'

export default class GraphqlQuery extends React.PureComponent {
  renderComponent = ({ data, error, loading, ...additionalData }) => {
    if (error) {
      //console.error(error)
      return null
    }

    if (loading) {
      return <Loading />
    }

    if (data) {
      return this.props.children(data, additionalData)
    }

    return null
  }

  render() {
    let { children, query, ...otherProps } = this.props

    return (
      <Query query={ query } { ...otherProps }>
        { this.renderComponent }
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/GraphqlQuery/GraphqlQuery.js